import styled from "styled-components";

const logoMask =
  "<svg style='width: 42px; height: 20px' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 42 20' ><path fill='currentColor' d='M36.9 14.25c-1.03 0-1.78-.15-2.25-.44-.46-.3-.69-.8-.69-1.52 0-.47.12-1.14.35-1.99.28-1 .59-1.74.93-2.26.34-.52.78-.9 1.32-1.1a5.81 5.81 0 0 1 2.13-.33c.96 0 1.66.1 2.08.32.42.22.63.6.63 1.17 0 .3-.06.66-.17 1.08H39.6c.03-.17.04-.32.04-.44 0-.26-.06-.43-.2-.52-.13-.09-.36-.14-.7-.14-.52 0-.96.08-1.3.24-.34.16-.63.43-.87.8-.24.37-.45.88-.63 1.53-.16.55-.24.97-.24 1.24 0 .32.1.55.3.68a2 2 0 0 0 1.03.2c.5 0 .86-.06 1.1-.18.23-.12.44-.38.64-.76h1.76c-.21.66-.45 1.16-.72 1.5-.27.34-.63.58-1.07.72-.44.13-1.05.2-1.82.2ZM29 14.25c-.71 0-1.28-.06-1.7-.17-.42-.12-.74-.3-.94-.56-.2-.28-.3-.64-.3-1.1 0-.54.14-1.28.41-2.2.28-.98.59-1.72.91-2.22.33-.5.75-.86 1.25-1.07.52-.21 1.2-.32 2.07-.32.99 0 1.7.13 2.13.4.44.27.66.74.66 1.41 0 .62-.19 1.51-.56 2.68h-4.98c-.13.4-.19.69-.19.89 0 .3.1.5.31.63.2.12.53.18.96.18.55 0 .95-.07 1.2-.2.26-.14.46-.4.62-.8h1.81a5.81 5.81 0 0 1-.9 1.5c-.3.35-.66.6-1.1.73-.41.15-.97.22-1.66.22Zm2.62-4.44c.08-.37.12-.67.12-.88 0-.31-.08-.53-.24-.66-.16-.15-.44-.22-.83-.22-.67 0-1.19.14-1.56.41a2.4 2.4 0 0 0-.83 1.35h3.34Z' /><path fill='currentColor' fill-rule='evenodd' d='M20.54 13.95c.32.22.86.32 1.61.32.53 0 1.25-.05 2.18-.16l.24-1.5c-.37.05-.71.1-1.04.13-.32.03-.6.05-.86.05-.32 0-.55-.03-.67-.07-.12-.06-.18-.16-.18-.3 0-.07.04-.28.12-.62l.26-.9h-1.69l-.22.8c-.14.47-.21.88-.21 1.23 0 .45.15.8.46 1.02Zm.26-4.05.47-1.66h-1.82l.75-1.45h1.55l.5-1.82 1.73-.35-.6 2.17h2.73l-.42 1.45h-2.74l-.47 1.66H20.8ZM21.2 10.9h-1.69l.29-1h1.68l-.28 1Z' clip-rule='evenodd' /><path fill='currentColor' d='M2 5.9h1.5l.3-1H2.51L2 5.9Z' /><path fill='currentColor' fill-rule='evenodd' d='m13.1 10.13-1.17 3.99h-1.69L12.6 5.9h.78l.3-1h-.79l.29-1h1.68L13.08 10l4.03-3.2h2.08L15 10.05l.49.84H15l-.3 1h1.35l1.29 2.22h-2.08l-2.16-3.99Z' clip-rule='evenodd' /><path fill='currentColor' d='M10.21 5.9h1.82l.3-1h-1.6l-.52 1ZM9.85 10.9l.06-.23c.27-.94.41-1.69.41-2.23 0-.66-.2-1.14-.59-1.42-.4-.28-1.02-.42-1.9-.42-.45 0-.83.07-1.12.2-.29.12-.61.36-.97.71h-.1l.48-1.61h-.9l.29-1h.9l.26-.84h-1.7l-.86 3h-.59l-.52 1h.82l-.29 1h1.86a2 2 0 0 1 .76-.73c.32-.17.7-.26 1.17-.26.44 0 .75.07.94.2.2.12.3.35.3.68a9.62 9.62 0 0 1-.44 1.95h1.73ZM5.97 14.42c-.5 0-.88-.07-1.14-.21a1.9 1.9 0 0 1-.69-.76h-.18l-.24.83h-1.7l.07-.22H.98l.52-1h.88l.33-1.16h-.5l.53-1H3l.24-.84h1.69a10.12 10.12 0 0 0-.48 2.06c0 .3.09.52.26.64.16.13.44.19.82.19.5 0 .93-.08 1.27-.24.33-.17.62-.44.85-.81H9.5c-.17.43-.34.78-.5 1.07-.33.53-.72.9-1.19 1.13-.47.21-1.08.32-1.85.32ZM2 10.06H1l.52-1h1l-.52 1Z' /></svg>";
const badgeMask =
  "<svg xmlns='http://www.w3.org/2000/svg' width='52' height='23' fill='none'><g clip-path='url%28#a%29'><path fill='#000' fill-rule='evenodd' d='M52 0H0v23h52V0Zm-1 1H1v20h50V1Z' clip-rule='evenodd'/></g><defs><clipPath id='a'><path fill='#fff' d='M0 0h52v23H0z'/></clipPath></defs></svg>";

const Badge = styled.button`
  position: relative;
  background: #fff;

  .bktec__logoMask {
    mask-image: url("data:image/svg+xml;utf8,${encodeURIComponent(logoMask)}");
    overflow: hidden;
    position: absolute;
    top: 1px;
    left: 4px;
  }

  .bktec__badgeMask {
    mask-image: url("data:image/svg+xml;utf8,${encodeURIComponent(badgeMask)}");
    width: 52px;
    height: 23px;
    overflow: hidden;
    overflow: hidden;
    position: relative;
    opacity: 0.66;
  }

  /* Default bktec styling */
  .bktec__fill,
  .bktec__outline {
    width: 100%;
    height: 100%;
  }

  .bktec__fill {
    background: #555;
  }

  .bktec__outline {
    background: #ccc;
  }

  /* Passed and failed styling */
  &.bktec--passed .bktec__fill,
  &.bktec--failed .bktec__fill {
    background: #333;
  }

  &.bktec--passed .bktec__outline {
    background: var(--green-500, #00be13);
  }

  &.bktec--failed .bktec__outline {
    background: var(--red-500, #f83f23);
  }

  /* Running styling */
  @keyframes bktecRunning {
    from {
      transform: translateX(0) translateY(0);
    }

    to {
      transform: translateX(-50%) translateY(50%);
    }
  }

  /* Resize the gradient shapes so that they can be transitioned in terms of position */
  &.bktec--running .bktec__fill {
    width: 168px;
    height: 44px;
  }

  &.bktec--running .bktec__outline {
    width: 212px;
    height: 92px;
  }

  &.bktec--running .bktec__fill,
  &.bktec--running .bktec__outline {
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(
      45deg,
      hsl(260deg 97% 62%) 0%,
      hsl(336deg 100% 54%) 13%,
      hsl(43deg 100% 53%) 25%,
      hsl(336deg 100% 54%) 37%,
      hsl(260deg 97% 62%) 50%,
      hsl(336deg 100% 54%) 63%,
      hsl(43deg 100% 53%) 75%,
      hsl(336deg 100% 54%) 87%,
      hsl(260deg 97% 62%) 100%
    );
    animation: bktecRunning 2s linear infinite;
  }
`;

const BktecLogo = ({ state, ...rest }) => (
  <Badge {...rest} title="bktec" className={`bktec--${state}`}>
    <div className="bktec__logoMask" style={{ width: 42, height: 20 }}>
      <div className="bktec__fill" />
    </div>
    <div className="bktec__badgeMask">
      <div className="bktec__outline" />
    </div>
  </Badge>
);

export { BktecLogo };
